import { useState, useEffect } from 'react';
import { cliengoQueries } from '@cliengo/mfe-utils/hooks';
import { Typography, Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { AccountWithFeatures } from '@cliengo/mfe-utils/types';

import { useTranslate } from '@/hooks';
import { getDaysUntilDate } from '@/utils/getDaysUntilDate';

export const FreeTrialBanner = ({ color = '#21005D' }) => {
  const { data: accountData } = cliengoQueries.account();
  const [daysRemaining, setDaysRemaining] = useState(0);
  const [isTrialEnded, setIsTrialEnded] = useState(false);
  const { t } = useTranslate('freeTrial');

  useEffect(() => {
    const account = accountData as AccountWithFeatures & {
      freeTrialExpirationDate?: string;
    };

    if (account?.freeTrialExpirationDate) {
      const daysLeft = getDaysUntilDate(account.freeTrialExpirationDate);

      setDaysRemaining(daysLeft);

      const expirationDate = new Date(account.freeTrialExpirationDate);
      const currentDate = new Date();

      if (currentDate >= expirationDate) {
        setIsTrialEnded(true);
      }
    }
  }, [accountData]);

  return (
    <>
      {!isTrialEnded ? (
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          sx={{
            '@media (max-width: 425px)': {
              justifyContent: 'center',
            },
          }}
        >
          <Typography
            marginRight={'10px'}
            fontSize={'13px'}
            color={'rgb(97, 80, 173)'}
            sx={{
              '@media (max-width: 425px)': {
                display: 'none',
              },
            }}
          >
            <Trans
              i18nKey="freeTrial.title"
              values={{ daysRemaining }}
              components={[<span key="hightlight" style={{ color }} />]}
            />
          </Typography>
          <Link
            to="/account/plans"
            style={{
              textDecoration: 'none',
            }}
          >
            <Button
              sx={{
                background:
                  'linear-gradient(90deg, rgb(218, 96, 240) 0%, rgb(125, 96, 240) 100%)',
                color: 'white',
                padding: '5px 20px',
                fontSize: '12px',
                minHeight: 'max-content',
                '@media (max-width: 425px)': {
                  padding: '3px 9px',
                  fontSize: '12px',
                },
              }}
            >
              {t('button')}
            </Button>
          </Link>
        </Box>
      ) : (
        <Box display="flex" flexDirection="row" alignItems="center">
          <Typography
            marginRight={'10px'}
            fontSize={'13px'}
            color={'rgb(97, 80, 173)'}
          >
            {t('freeTrialEnded')}
            <Link
              to="/account/plans"
              style={{
                textDecoration: 'none',
                color: '#21005D',
                fontWeight: 700,
              }}
            >
              {t('freeTrialEndedSubscribe')}
            </Link>
          </Typography>
        </Box>
      )}
    </>
  );
};
